var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66168 1.44266C9.21053 0.352868 8.02113 -0.227184 6.88446 0.0833487L1.72844 1.48954C0.708953 1.77077 0 2.69651 0 3.75116C0 18.2466 11.7534 30 26.2488 30C27.3035 30 28.2292 29.291 28.5105 28.2716L29.9166 23.1155C30.2272 21.9789 29.6471 20.7895 28.5573 20.3383L22.9326 17.9947C21.9775 17.5963 20.8702 17.8716 20.2198 18.6743L17.8527 21.5629C13.7279 19.6118 10.3882 16.2721 8.43713 12.1473L11.3257 9.78605C12.1284 9.12983 12.4037 8.02831 12.0053 7.07328L9.66168 1.44852V1.44266Z",
    fill: "#4987FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/Call.61f693d51f78c45f2e0d5238cf882dd2.svg";
export { ForwardRef as ReactComponent };